export const GST_REGISTRATION = "201727751R";
export const SINGAPORE_TAX = 0.09;

// PayNow payments are confirmed manually, so a recent client indication shows as Processing.
export const PAYNOW_PROCESSING_DAYS = 3;

export function getInvoiceDetailPath(id: string) {
  return `/profile/invoices/${id}`;
}

export function getInvoicePdfPath(id: string, token: string) {
  return `/profile/invoices/${id}/view-invoice-pdf?token=${token}`;
}

export function getReceiptPdfPath(id: string, token: string) {
  return `/profile/invoices/${id}/view-receipt-pdf?token=${token}`;
}
